// compCd(회사코드)를 URL 경로 세그먼트에 넣기 위한 경량 인코딩.
//
// 주의: 이것은 암호학적 비밀이 아니다. SPA이므로 키가 클라이언트 번들에
// 그대로 노출되며, compCd 자체도 사용자에게 비밀이 아니다(실제 접근 격리는
// Keycloak organization 멤버십이 서버 측에서 강제한다). 여기서는 그저
// raw compCd가 URL에서 한눈에 보이지 않도록 가볍게 흐트러뜨릴 뿐이다.
//
// 방식: compCd의 각 문자를 고정 키로 XOR한 뒤 base64url(패딩 제거)로 인코딩한다.
// decode는 정확히 역순으로 수행하고, 최종 결과가 compCd 도메인 패턴과
// 일치하지 않으면(잘못된 입력) null을 반환한다.
//
// 불변식: 유효한 모든 compCd x에 대해 decodeOrgCode(encodeOrgCode(x)) === x.

const XOR_KEY = [0x5a, 0x3c, 0x7e, 0x11, 0x2d];
const COMP_CD_PATTERN = /^[A-Z0-9]([A-Z0-9-]{0,8}[A-Z0-9])?$/;

function xorWithKey(input: string): string {
  let out = '';
  for (let i = 0; i < input.length; i++) {
    const keyByte = XOR_KEY[i % XOR_KEY.length];
    out += String.fromCharCode(input.charCodeAt(i) ^ keyByte);
  }
  return out;
}

function toBase64Url(raw: string): string {
  return btoa(raw).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(encoded: string): string {
  const padded = encoded + '='.repeat((4 - (encoded.length % 4)) % 4);
  const standard = padded.replace(/-/g, '+').replace(/_/g, '/');
  return atob(standard);
}

/**
 * compCd를 URL 경로 세그먼트로 쓸 수 있는 문자열로 인코딩한다.
 * 결과는 base64url 문자셋(A-Z a-z 0-9 - _)만 사용하며 패딩이 없다.
 */
export function encodeOrgCode(compCd: string): string {
  return toBase64Url(xorWithKey(compCd));
}

/**
 * encodeOrgCode의 결과를 원래 compCd로 복원한다.
 * 디코딩 불가능하거나 복원된 값이 compCd 도메인 패턴
 * (^[A-Z0-9]([A-Z0-9-]{0,8}[A-Z0-9])?$)과 맞지 않으면 null을 반환한다.
 */
export function decodeOrgCode(encoded: string): string | null {
  let raw: string;
  try {
    raw = fromBase64Url(encoded);
  } catch {
    return null;
  }

  const compCd = xorWithKey(raw);
  return COMP_CD_PATTERN.test(compCd) ? compCd : null;
}
